import { RecommendDoulaDialog } from "#/pages/provider-finder/recommend-doula/RecommendDoulaDialog"
import { Link } from "@carrotfertility/carotene-core"
import React, { useState } from "react"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

export function RecommendDoulaLink({ children }: { children: React.ReactNode }): JSX.Element {
  const [openDialog, setOpenDialog] = useState(false)
  const { mutate: trackMemberAction } = useMemberActionTracking()
  return (
    <>
      <Link
        sx={{
          textAlign: "start",
          verticalAlign: "baseline"
        }}
        component="button"
        color="inherit"
        onClick={() => {
          trackMemberAction({
            memberActionTaken: MemberActions.PROVIDER_FINDER_RECOMMEND_A_DOULA_OPENED,
            metaData: {
              location: "Digital Benefits Guide"
            }
          })
          setOpenDialog(true)
        }}
      >
        {children}
      </Link>
      <RecommendDoulaDialog open={openDialog} onClose={() => setOpenDialog(false)} />
    </>
  )
}
